import { Injectable } from '@angular/core';
import { Utility } from '../shared/utility/utility';
import { UserDetailsService } from '../services/user-details.service';
import { Subject } from 'rxjs';
import { SessionLimitService } from '../services/session-limit.service';
@Injectable()
export class RealityCheckService {
  private availableSessionLimit;
  private sessionLimit = new Subject<string>();
  sessionLimit$ = this.sessionLimit.asObservable();

  sessionLimitInterval;

  constructor(
    private utils: Utility,
    private userDetailsService: UserDetailsService,
    private sessionLimitService: SessionLimitService) { }

  getSessionDetails(modalId) {
    Promise.resolve(this.sessionLimitService.getSessionLimit())
      .then(sessionData => {
        if (sessionData) {
          this.updateSessionVariable(sessionData["limits"] && sessionData["limits"].overall.value ? sessionData["limits"].overall.value : 0);
          if (modalId) {
            this.utils.closeModal(modalId);
          }
        }
      });
  }

  setSessionVariable(sessionKey, sessionValue) {
    sessionStorage.setItem(sessionKey, JSON.stringify(sessionValue));
    this.sessionLimit.next("");
  }

  updateSessionVariable(newLimit) {
    let sessionValue = JSON.parse(sessionStorage.getItem("session"))
    if (sessionValue && newLimit !== sessionValue.sessionLimit) {
      sessionValue.availableSessionLimit =
        sessionValue.availableSessionLimit > 1 && newLimit > sessionValue.sessionLimit
          ? (newLimit - sessionValue.sessionLimit) * 60
          : sessionValue.availableSessionLimit > 1 && newLimit <= sessionValue.sessionLimit
            ? sessionValue.availableSessionLimit - ((sessionValue.sessionLimit - newLimit) * 60)
            : newLimit * 60;
      sessionValue.sessionLimit = newLimit;
      sessionStorage.setItem("session", JSON.stringify(sessionValue));
    } else if (
      (!sessionValue && newLimit > 0) ||
      (sessionValue && newLimit === sessionValue.sessionLimit && sessionValue.availableSessionLimit <= 1 && newLimit > 0)
    ) {
      let sessionNewValues = {
        sessionLimit: newLimit,
        availableSessionLimit: newLimit * 60
      }
      this.setSessionVariable("session", sessionNewValues);
    } else if (newLimit === 0) {
      sessionStorage.removeItem("session");
    }
    this.startLoginSession();
  }

  resetSessionVariable() {
    let sessionValue = JSON.parse(sessionStorage.getItem("session"))
    let sessionKey = "session";
    sessionValue.availableSessionLimit = sessionValue.sessionLimit * 60;
    sessionStorage.setItem(sessionKey, JSON.stringify(sessionValue));
    this.startLoginSession();
  }

  startLoginSession() {
    if (!this.sessionLimitInterval) {
      this.sessionLimitInterval = setInterval(() => {
        let sessionLimit = JSON.parse(sessionStorage.getItem("session"))
        if (sessionLimit) {
          if ((sessionLimit.availableSessionLimit - 1) > 0) {
            sessionLimit.availableSessionLimit = sessionLimit.availableSessionLimit - 1;
            sessionStorage.setItem("session", JSON.stringify(sessionLimit));
          } else {
            clearInterval(this.sessionLimitInterval);
            this.sessionLimitInterval = undefined;
            this.utils.openMultiModal("sessionExpiredModal");
          }
        } else {
          clearInterval(this.sessionLimitInterval);
          this.sessionLimitInterval = undefined;
        }

      }, 1000);
    }
  }
  doLogout() {
    this.userDetailsService.doLogout();
  }
}
